import { Routes, Route } from 'react-router-dom';

import App from './App';
import LoginPage from './login/LoginPage';

import UsersPage from './pages/UsersPage'
import UserPage from './pages/UserPage'
import PageNotFound from './pages/PageNotFound';
import ProductsPage from './pages/ProductsPage';
import ProductPage from './pages/ProductPage';
import MaintenancesPage from './pages/MaintenancesPage';
import MaintenancePage from './pages/MaintenancePage';
import ClientsPage from './pages/ClientsPage';
import ClientPage from './pages/ClientPage';
import DashboardPage from './pages/DashboardPage';
import StatsPage from './pages/StatsPage';


const Navigation = () => {
  return (
    <Routes>
      <Route path="*" element={<PageNotFound />} />
      <Route path="/login" element={<LoginPage />} />


      <Route path="/" element={<App />}>

  <Route index element={<DashboardPage />} />

        <Route path="dashboard" element={<DashboardPage />} />


        <Route path="settings">
          <Route path="stats" element={<StatsPage />} />

          <Route path="products" element={<ProductsPage />} />
          <Route path="product/:id" element={<ProductPage />} />
          <Route path="product" element={<ProductPage />} />

          <Route path="maintenances" element={<MaintenancesPage />} />
          <Route path="maintenance/:id" element={<MaintenancePage />} />
          <Route path="maintenance" element={<MaintenancePage />} />

          <Route path="clients" element={<ClientsPage />} />
          <Route path="client/:id" element={<ClientPage />} />
          <Route path="client" element={<ClientPage />} />

          <Route path="users" element={<UsersPage />} />
          <Route path="user/:id" element={<UserPage />} />
          <Route path="user" element={<UserPage />} />

        </Route>

      </Route>
    </Routes>
  );
};

export default Navigation;
